// extracted by mini-css-extract-plugin
module.exports = {"secondFold":"secondFold_secondFold__U2XT5","editDiv":"secondFold_editDiv__df22c","editIcon":"secondFold_editIcon__08XUg","heading":"secondFold_heading__e_sZc"};